import React, {useEffect} from 'react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import {Link, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import PaidOrderDetail from "./Detail/Paid";
import DraftOrderDetail from "./Detail/Draft";
import {getOrderDetail} from "../../slices/thunks";
import {AppDispatch} from "../../store";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";

const OrderDetail: React.FC = () => {
    const {orderId} = useParams<{ orderId: string }>();
    const dispatch = useDispatch<AppDispatch>();
    const {order, loading} = useSelector((state: any) => state.OrderDetail);
    const [currentStatusOrder, setCurrentStatusOrder] = React.useState<string>("");

    useEffect(() => {
        if (orderId) {
            dispatch(getOrderDetail(orderId));
        }
    }, [dispatch, orderId]);

    useEffect(() => {
        if (order?.status) {
            setCurrentStatusOrder(order.status);
        }
    }, [order?.status]);

    const renderOrder = () => {
        if (!order) {
            if (loading.getOrder) {
                return <p className="text-center py-5">Đang tải thông tin đơn hàng...</p>;
            }
            return <p className="text-center py-5">Không tìm thấy thông tin đơn hàng.</p>;
        }

        switch (currentStatusOrder) {
            case "paid":
                return <PaidOrderDetail order={order} />;
            case "draft":
                return <DraftOrderDetail order={order} />;
            default:
                return <PaidOrderDetail order={order} />;
        }
    }

    return (
        <React.Fragment>
            <div className="position-relative mb-9">
                <div className="header-area" id="headerArea">
                    <div
                        className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                        <div className="back-button me-2">
                            <Link
                                to="/home"
                                onClick={() => {
                                    window.history.back();
                                }}
                            >
                                <i className="mdi mdi-arrow-left"></i>
                            </Link>
                        </div>

                        <div className="page-heading">
                            <h6 className="mb-0">{order?.order_number || orderId}</h6>
                        </div>

                        <HeaderSidebarToggle className="ms-2" />
                    </div>
                </div>
                <div className="page-content-wrapper">
                    <div className="container">
                        {renderOrder()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OrderDetail;
